// Subscription health block (approved HTML component: subscription-health).
import type { ReactNode } from 'react';

export interface SubscriptionHealthProps {
  tiles: Array<{ label: string; value: string; caption: string }>;
  rows: Array<{ label: string; value: string }>;
}

export function SubscriptionHealth({ tiles, rows }: SubscriptionHealthProps): ReactNode {
  return (
    <section className="exec-card" data-component="subscription-health">
      <div className="exec-head">
        <h2>Subscription health</h2>
        <small>Subscribers ≠ subscriptions</small>
      </div>
      <div className="exec-body sub-health">
        <div className="sub-primary">
          {tiles.map(tile => (
            <div key={tile.label} className="sub-tile">
              <span>{tile.label}</span>
              <strong>{tile.value}</strong>
              <small>{tile.caption}</small>
            </div>
          ))}
        </div>
        <table className="sub-table">
          <tbody>
            {rows.map(row => (
              <tr key={row.label}>
                <td>{row.label}</td>
                <td>{row.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
